export default "__VITE_ASSET__CYv1j8vn__"